import { createContext, useContext } from "react";

import type { GeoLocation } from "../hooks/useGeoLocation";

export type SortMode = "relevance" | "distance";

export type SearchRankingContextType = {
  sortMode: SortMode;
  userLocation: GeoLocation | null;
  locationDenied: boolean;
  setSortMode: (mode: SortMode) => void;
  requestLocation: () => Promise<GeoLocation>;
};

export const SearchRankingContext = createContext<SearchRankingContextType | null>(null);

/*
 * Will return null if not inside a SearchRanking context
 */
export const useSearchRanking = (): SearchRankingContextType | null => {
  const context = useContext(SearchRankingContext);
  return context;
};
